const name = "paguelofacilCore";

function hex_to_ascii(str) {
    const hexString = str;
    let strOut = '';
    for (let x = 0; x < hexString.length; x += 2) {
        strOut += String.fromCharCode(parseInt(hexString.substr(x, 2), 16));
    }
    return strOut;
}

export const ascii_to_hex = (str) => {
    let hex;
    try {
        hex = unescape(encodeURIComponent(str))
            .split("")
            .map(function (v) {
                return v.charCodeAt(0).toString(16);
            })
            .join("");
    } catch (e) {
        hex = str;
    }
    return hex;
};

function IsJsonString(str) {
    try {
        JSON.parse(JSON.stringify(str));
    } catch (e) {
        return false;
    }
    return true;
}

function encode(_str) {
    let str = _str;
    if (IsJsonString(_str)) {
        str = JSON.stringify(_str);
    }
    return ascii_to_hex(btoa(str));
}

function decode(_str) {
    return atob(hex_to_ascii(_str));
}

function encodeHex(_str) {
    let str = _str;
    if (IsJsonString(_str)) {
        str = JSON.stringify(_str);
    }
    return ascii_to_hex(str);
}


export const getNamesUser = (name) => {
    try {
        const fullname = name.trim().split(" ");

        let firstname = "";
        let lastname = "";

        if (fullname.length === 4) {
            firstname = fullname[0] + " " + fullname[1];
            lastname = fullname[2] + " " + fullname[3];
        }
        if (fullname.length === 3) {
            firstname = fullname[0];
            lastname = fullname[1] + " " + fullname[2];
        }
        if (fullname.length === 2) {
            firstname = fullname[0];
            lastname = fullname[1];
        }

        return { firstname, lastname };
    } catch (e) {
        return { firstname: "", lastname: "" };
    }
};

// https://stackoverflow.com/a/2998874/1673761
export const twoDigits = (num) => String(num).padStart(2, "0");

export const cryptoUtil = { name, encode, decode, encodeHex, getNamesUser, twoDigits };